import "i18next"
import { defineLocalizationResources } from "./localization-resources"

const en = {
  errors: {
    unexpected: "Something went wrong.",
    saveFailed: "The changes could not be saved.",
    retry: "Try again",
    localizationUnavailable: "Language resources could not be loaded.",
    commandFailed: "The action could not be completed.",
    network: "The server could not be reached. Check the connection and try again.",
    unauthorized: "Your session has expired. Sign in again.",
    forbidden: "You do not have permission to do this.",
    notFound: "The requested data no longer exists.",
    conflict: "Someone else changed this data. Reload it and try again.",
    server: "The server ran into a problem. Try again later.",
    protocol: "The server sent an answer that this application cannot process.",
  },
  editing: {
    removeRows: "Delete the selected rows?",
  },
} as const

const nl = {
  errors: {
    unexpected: "Er is iets misgegaan.",
    saveFailed: "De wijzigingen konden niet worden opgeslagen.",
    retry: "Opnieuw proberen",
    localizationUnavailable: "De taalbestanden konden niet worden geladen.",
    commandFailed: "De actie kon niet worden uitgevoerd.",
    network: "De server is niet bereikbaar. Controleer de verbinding en probeer het opnieuw.",
    unauthorized: "Je sessie is verlopen. Meld je opnieuw aan.",
    forbidden: "Je hebt geen toestemming om dit te doen.",
    notFound: "De gevraagde gegevens bestaan niet meer.",
    conflict: "Iemand anders heeft deze gegevens gewijzigd. Laad ze opnieuw en probeer het nog eens.",
    server: "Er is een probleem op de server. Probeer het later opnieuw.",
    protocol: "De server gaf een antwoord dat deze toepassing niet kan verwerken.",
  },
  editing: {
    removeRows: "De geselecteerde rijen verwijderen?",
  },
} as const

declare module "i18next" {
  interface CustomTypeOptions {
    enableSelector: true
  }
  interface ResourceNamespaceMap {
    "florisoft-framework": typeof en
  }
}

export const frameworkLocalizationResources = defineLocalizationResources({
  namespace: "florisoft-framework",
  resources: { en, nl },
})
